import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';
import { useTranslation } from 'next-i18next';

import HeaderStyle from './style';

import { useAppData } from 'src/helpers/use';

type HeaderProps = {
  onClickContactUs?: () => void;
};

const Header = ({ onClickContactUs }: HeaderProps) => {
  const { t } = useTranslation('business');
  const { appData, isLoading } = useAppData();

  const logo = appData?.logo;
  return (
    <HeaderStyle>
      <AppBar position="fixed">
        <div className="container header-container">
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={6} sm={2} display="flex">
              {isLoading || !logo ? (
                <Skeleton variant="rectangular" width={140} height={44} />
              ) : (
                <a target={logo.target_url} href={logo.link_url || '/'} style={{ display: 'flex' }}>
                  <img className="logo" src="/static/icons/skl-logo.svg" alt={t('skilllane_b2b')} />
                </a>
              )}
            </Grid>
            <Grid item sm={1} lg={2} sx={{ display: { xs: 'none', sm: 'block' } }} />
            <Grid item sm={6} lg={6} sx={{ display: { xs: 'none', sm: 'flex' } }} justifyContent="flex-end">
              <a href="tel:061-420-6317" target="_blank" rel="noreferrer">
                <Box className="contact-box">
                  <PhoneIcon /> 061-420-6317
                </Box>
              </a>
              <a href="mailto:b2b.info@SkillLane.com" target="_blank" rel="noreferrer">
                <Box className="contact-box">
                  <EmailIcon /> b2b.info@SkillLane.com
                </Box>
              </a>
            </Grid>
            <Grid item xs={6} sm={3} lg={2} display="flex" justifyContent="flex-end">
              <Button variant="outlined" className="join-button" onClick={onClickContactUs}>
                {t('join_us')}
              </Button>
            </Grid>
          </Grid>
        </div>
      </AppBar>
    </HeaderStyle>
  );
};

export default Header;
